export default {"src":"/_next/static/media/search-gray.ad3d44c2.svg","height":16,"width":16};